import styled from '@emotion/styled';

export const TableFooter = styled.div`
  padding: 15px 0;
`;
